import { lazy } from 'react';

export const ProfileLazy = lazy(() => import('./Profile'));
